<template>
    <div class="cart-items" :class="viewMode">

        <div class="holidays" v-if="isHolidayDelivery() === true">
            <p>
                Szanowny Kliencie, dziękujemy za zakupy w legrand.pl,<br>
                z uwagi na okres świąteczny wszystkie zamówienia złożone<br>
                od dnia <strong>20.12.2018</strong> będą realizowane po <strong>3.01.2019</strong>.<br>
                Za utrudnienia bardzo przepraszamy.
            </p>
        </div>

        <div class='item-list-table'>
            <div class="cart-row" :key="sku" v-for="(item, sku) in items" :class="getGenderClass(item.gender)">
                <div class='cart-name' v-html="getModelName(item)"></div>
                <div class='cart-size spec'><span class="circle">{{ getSizeName(item,sku) }}</span></div>
                <div class='cart-img'>
                    <div :style="getImage(item,sku)" :title='sku'>&nbsp;</div>
                </div>
                <div class='cart-qty'>
                    <div class='controls'>
                        <div class='cart-dec' v-show="viewMode==='details'" v-on:click="decrease(sku)"><span
                                v-html="renderIconSvg('minus')"></span></div>
                        <input v-show="viewMode==='details' || viewMode==='preview'" type="text"
                               :data-sku="sku" :value="item.qty"
                               @input="itemQtyChanged">
                        <div v-show="viewMode==='summary'" class='cart-static-qty'>{{ item.qty }}</div>
                        <div class='item-qty-unit'>szt.</div>
                        <div class='cart-inc' v-show="viewMode==='details'" v-on:click="increase(sku)"><span
                                v-html="renderIconSvg('plus')"></span></div>
                    </div>
                </div>
                <div class='cart-price symbol' v-show="viewMode!='preview'">&times;</div>
                <div class='cart-price' v-html="getPrice(item.price)" v-show="viewMode!='preview'"></div>
                <div class='cart-price symbol' v-show="viewMode!='preview'">&equals;</div>
                <div class='cart-price amount' v-html="getPrice(item.price * item.qty) "></div>

                <div class="item-remove" v-show="viewMode==='preview' || viewMode==='details'"
                     v-on:click="removeItem(sku)">
                    <span v-html="renderIconSvg('trash')"></span>
                </div>

            </div>
            <div class="cart-row summary items-total">
                <p v-translate="'CART_items_total'">Łączna wartość produktów:</p>
                <p class="total-value" v-html="getPrice(itemsTotal)"></p>
            </div>


        </div>
    </div>
</template>

<script>

    import store from "./../../store/index"

    export default {
        name: "CartItemsList",
        props: {
            viewMode: String,
        },
        computed: {
            items() {
                return store.getters.items;
            },
            itemsTotal() {
                return store.getters.itemsTotal;
            }
        },
        data() {
            return {
                indicator: 0,
                universal: 'Uni',
            }
        },

        methods: {


            itemQtyChanged(e) {
                console.log('itemQtyChanged');
                store.dispatch('setItemQty', {sku: e.target.dataset.sku, value: e.target.value});
            },
            increase(sku) {
                store.dispatch('increase', sku);
            },
            decrease(sku) {
                store.dispatch('decrease', sku);
            },
            removeItem(sku) {
                store.dispatch('remove', sku);
            },

            getGenderClass(gender) {
                return 'kind-' + gender.toLowerCase();
            },

            getSizeName(item, sku) {
                let sizeName = "";
                let that = this;
                let type = parseInt(item.type) === 3 ? 'bikes' : 'accessories';
                _.forEach(window.env.data[type], p => {
                    _.forEach(p.combinations, c => {

                        if (c.SKU === sku) {
                            sizeName = c.size;
                            if (c.size.toLowerCase() === 'universal') {
                                sizeName = that.universal;
                            }
                            return 1;
                        }
                    });
                });
                return sizeName;
            },
            getPhoto: function (type, color, style) {
                return 'background-image: url(\'' +
                    env.baseUrl + 'photos/styles/' + style + '/' + window.env.collection + '/' + type + '/legrand_' +
                    color.photo_color.toLowerCase() + (color.is_glossy === '1' ? '_polysk' : '_mat') +
                    '.png\');'
            },
            getModelName(item) {
                let name = item.name;
                if (parseInt(item.type) === 3) {
                    name = this.$options.filters.bike_name(item.name, item.gender)
                }

                name += "<div class='mobile cart-price'>" + this.getPrice(item.price) + "</div>";

                return name;
            },
            getPrice(price) {
                return this.$options.filters.full_price(price)
            },
            renderIconSvg(icon) {
                let svg = '<svg width="1.09375vw" height="1.09375vw" viewBox="0 0 21 21" enable-background="new 0 0 21 21" xml:space="preserve">';
                switch (icon) {
                    case "plus" :
                        svg += '<circle stroke-miterlimit="10" cx="10.5" cy="10.5" r="10"/>';
                        svg += '<line x1="10.5" y1="6" x2="10.5" y2="15"/><line  x1="15" y1="10.5" x2="6" y2="10.5"/>';
                        break;
                    case "minus" :
                        svg += '<circle stroke-miterlimit="10" cx="10.5" cy="10.5" r="10"/>';
                        svg += '<line  x1="15" y1="10.5" x2="6" y2="10.5"/>';
                        break;
                    case "trash" :
                        svg += '<polygon points="7.718,-0.002 7.51,1.391 3.364,0.771 3.078,2.689 17.711,4.876 17.999,2.958 13.76,2.325 13.968,0.932 7.718,-0.002 "/>';
                        svg += '<path d="M17.762,6.833l0.002-1.22H3.001l0.002,1.22h1.062v13.484c0,0-0.017,0.641,0.583,0.681h11.47 c0.6-0.04,0.582-0.681,0.582-0.681V6.833H17.762z M7.192,18.218c0,0.334-0.271,0.604-0.605,0.604s-0.604-0.271-0.604-0.604V8.182 c0-0.334,0.271-0.605,0.604-0.605s0.605,0.271,0.605,0.605V18.218z M9.811,18.218c0,0.334-0.271,0.604-0.605,0.604 c-0.334,0-0.604-0.271-0.604-0.604V8.182c0-0.334,0.271-0.605,0.604-0.605c0.334,0,0.605,0.271,0.605,0.605V18.218z M12.351,18.218 c0,0.334-0.271,0.604-0.605,0.604s-0.605-0.271-0.605-0.604V8.182c0-0.334,0.271-0.605,0.605-0.605s0.605,0.271,0.605,0.605V18.218z M14.849,18.218c0,0.334-0.271,0.604-0.604,0.604s-0.604-0.271-0.604-0.604V8.182c0-0.334,0.271-0.605,0.604-0.605 s0.604,0.271,0.604,0.605V18.218z"/>';
                        break;
                }
                svg += "</svg>";
                return svg;

            },
            isHolidayDelivery() {
                // uwaga data: miesiąc/dzień/rok
                let start = new Date('12/20/2018');
                let end = new Date('01/02/2019');
                let now = new Date();
                return (now > start && now < end );
            },
            getImage(item, sku) {
                let photo = "no-photo.png";
                let that = this;
                let type = item.type === 3 ? 'bikes' : 'accessories';
                _.forEach(window.env.data[type], p => {
                    _.forEach(p.combinations, c => {
                        if (c.SKU === sku) {
                            photo = that.getPhoto(type, p.colors[c.main_color], 'list');
                            return 1;
                        }
                    });
                });
                return photo;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Cart/CartItemsList.vue